import { render } from "./AnnotationDetails.vue?vue&type=template&id=21369c27&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"

import "../../assets/scss/annotation_details.scss?vue&type=style&index=0&id=21369c27&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21369c27"]])

export default __exports__